/**
 * Phase 4 · Email typo suggestion dialog.
 *
 * Shown only when the backend `POST /api/orders/validate-email`
 * returned a `suggestion`. Presents:
 *   "You entered gil@gamil.com. Did you mean gil@gmail.com?"
 * with two actions:
 *   • USE gmail.com     — accepts the suggestion, updates the field
 *   • KEEP MY EMAIL     — proceeds with original (typo_overridden)
 *
 * Never auto-modifies the email — the user always chooses.
 */
import React from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader,
  AlertDialogTitle, AlertDialogDescription, AlertDialogFooter,
  AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

export default function EmailTypoSuggestionDialog({
  open, originalEmail, suggestedEmail, onKeep, onUse,
}) {
  if (!open || !suggestedEmail) return null;
  const suggestedDomain = (suggestedEmail || "").split("@")[1] || "";
  return (
    <AlertDialog open={open}>
      <AlertDialogContent data-testid="email-typo-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Did you mean {suggestedEmail}?</AlertDialogTitle>
          <AlertDialogDescription>
            You entered <span className="font-mono">{originalEmail}</span>.
            {" "}This looks like a common typo — would you like to use{" "}
            <span className="font-mono">{suggestedEmail}</span> instead?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel
            data-testid="email-typo-keep"
            onClick={onKeep}
          >
            Keep my email
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="email-typo-use"
            onClick={onUse}
          >
            Use {suggestedDomain}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
